ACC.cms = {
  bindAll: function() {
    this.bindNavigationBarMenu();
  },

  bindNavigationBarMenu: function() {
    $('li.La ul ul a').each(function() {
      $(this).focus(function() {
        var menuParent = $(this).closest('ul').parent().closest('ul');

        $(this).addClass('focused');
        $(menuParent).addClass('dropdown-visible');
      });

      $(this).blur(function() {
        var menuParent = $(this).closest('ul').parent().closest('ul');

        $(this).removeClass('focused');

        /* eslint-disable  unicorn/explicit-length-check */
        if (!$('.focused', menuParent).length) {
          $(menuParent).removeClass('dropdown-visible');
          /* eslint-enable  unicorn/explicit-length-check*/
        }
      });
    });
  }
};

$(document).ready(function() {
  ACC.cms.bindAll();
});
